import React, { useEffect, useState } from "react";
import { CompaniesWithValue } from "../../constants/fetchData";
import {
  HugeiconsReceiptDollar,
  TablerCashRegister,
  TablerRocket,
} from "../../assets/icons/DashboardIcon";
import { getDashboardHeaders } from "../../services/dashboardService";
import { getDistributorNames, getUserId } from "../../Common/functions";

const Header = ({ userRole, setDistributor, distributor }) => {
  const [activeTab, setActiveTab] = useState("Day");
  const [stats, setStats] = useState(null); // <-- Add state for stats

  const baseTitles = [
    { title: "Total sales", icon: TablerCashRegister },
    { title: "Total leads", icon: TablerRocket },
    { title: "Total revenue", icon: HugeiconsReceiptDollar },
  ];

  const extractValues = (period) =>
    stats && stats[period]
      ? [
          stats[period][0], // totalSales
          stats[period][1], // totalLeads
          stats[period][3], // totalRevenue (skip index 2)
        ]
      : ["0", "0", "0"];

  const values = {
    Day: extractValues("Day"),
    Week: extractValues("Week"),
    Month: extractValues("Month"),
    Year: extractValues("Year"),
    // Overall: extractValues("Overall"), // Optional
  };

  const handleDistributorChange = async (e) => {
    const distributorName = e.target.value;
    setDistributor(distributorName);
  };

  const getDashboardHeaderDetails = async () => {
    try {
      const payload = {
        category: "sales tracking",
      };
      if (userRole !== "super_admin" && userRole !== "manager") {
        payload.distributor_name = getDistributorNames()[0];
      }
      if (userRole == "super_admin" && distributor!=="") {
        payload.distributor_name = distributor;
      }
      const result = await getDashboardHeaders(payload);
      if (result && result.data) {
        setStats(result.data); // <-- Update the stats here
      }
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
  };

  useEffect(() => {
    getDashboardHeaderDetails();
  }, [distributor]);

  return (
    <div>
      <div className="justify-between items-center py-4 gap-6 space-y-4">
        {userRole === "super_admin" ? (
          <>
            <div className="flex justify-between">
              <h1 className="text-3xl leading-9 font-bold text-text1">
                Dashboard
              </h1>
              <div className="primary-dropdown">
                <select
                  name="distributorSelect"
                  value={distributor}
                  onChange={handleDistributorChange}
                  className="rounded px-1 text-sm font-normal text-text1 focus:outline-none focus:ring-0 w-full cursor-pointer"
                >
                  <option value="">Select distributor</option>
                  {CompaniesWithValue.map((distributor) => (
                    <option key={distributor.value} value={distributor.label}>
                      {distributor.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="grid md:flex lg:flex justify-between gap-2">
              <h1 className="text-lg leading-9 font-semibold text-text1">
                Sales insights
              </h1>
              <div className="flex gap-2.5">
                {["Day", "Week", "Month", "Year"].map((tab) => (
                  <button
                    key={tab}
                    onClick={() => setActiveTab(tab)}
                    className={`button ${
                      activeTab === tab ? "active" : "inactive"
                    }`}
                  >
                    {tab}
                  </button>
                ))}
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="block sm:flex justify-between sm:space-y-0 space-y-2">
              <h1 className="text-3xl leading-9 font-bold text-text1">
                Dashboard
              </h1>
              <div className="flex gap-2.5">
                {["Day", "Week", "Month", "Year"].map((tab) => (
                  <button
                    key={tab}
                    onClick={() => setActiveTab(tab)}
                    className={`button ${
                      activeTab === tab ? "active" : "inactive"
                    }`}
                  >
                    {tab}
                  </button>
                ))}
              </div>
            </div>
          </>
        )}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {baseTitles.map((item, index) => (
          <div
            key={index}
            className="border border-gray-200 rounded-lg p-6 flex justify-between items-center w-full shadow-lg"
          >
            <div>
              <h2 className="text-sm font-medium text-text1 text-left">
                {item.title}
              </h2>
              <p className="text-3xl font-bold text-text1 text-left">
                {item.title === "Total revenue" && "₹"}
                {values[activeTab][index]}
              </p>
            </div>
            <item.icon className="text-gray-300 text-4xl" />
          </div>
        ))}
      </div>
      <hr className="mt-6" />
    </div>
  );
};

export default Header;
